var map = {
	"./11.png": "1fc9",
	"./12.png": "2307",
	"./13.png": "9c2a",
	"./14.png": "6743",
	"./19.png": "5884",
	"./20210924-1.png": "2667",
	"./20210924-2.png": "14ef",
	"./20210924-3.png": "b604",
	"./20210924-4.png": "cf32",
	"./20210924-5.png": "8096",
	"./20210924-6.png": "82a7",
	"./20210924-7.png": "6433",
	"./20210927-1.png": "7a0d",
	"./20210927-2.png": "fb5c",
	"./20210927-3.png": "0c11",
	"./20211006.png": "08c6",
	"./20211013.png": "adce",
	"./20211026.png": "bc4a",
	"./20220121.png": "8463",
	"./20220311.png": "840c",
	"./20220414.png": "94fd",
	"./20220509-1.png": "c2f9",
	"./20220509-2.png": "7f52",
	"./20220509-3.png": "4907",
	"./20220509-4.png": "f169",
	"./20220512-1.png": "13d9",
	"./20220623-1.png": "6624",
	"./20220704.png": "d9d6",
	"./20220802.png": "a294",
	"./20220829.png": "046c",
	"./20220902.png": "1cb3",
	"./20230223.png": "bd39",
	"./20230418.png": "01f1",
	"./20230517.png": "d4ce",
	"./20230809.png": "9c5b",
	"./20230907.png": "0a9a",
	"./20231113.png": "14e1",
	"./20231121.png": "a986",
	"./20231230.png": "f09d",
	"./20240322.png": "39cf",
	"./20240405.png": "8616",
	"./20241113.png": "0e92",
	"./21.jpg": "49cf",
	"./22.jpg": "9dcb",
	"./23.jpg": "d130",
	"./3.png": "346d",
	"./4.png": "ff13",
	"./5.png": "30fe",
	"./7.png": "6d00",
	"./9.png": "18ad",
	"./img1_medicalai.png": "07c0",
	"./img2_bigdataplatform.png": "a318",
	"./img3_digitaltherapeutics.png": "5f7d",
	"./news_img.jpg": "3b31"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09e7";